export default __webpack_public_path__ + "static/media/deviceTemplate.45508111.csv";